import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import auth from './modules/auth';
import users from './modules/users';
import producao from './modules/producao';
import empresa from './modules/empresa';
import permissao from './modules/permissao';
import controlesequencia from './modules/controlesequencia';
import contrato from './modules/contrato';
import modulos from './modules/modulos';
import documentopagar from './modules/documentopagar';
import documentoreceber from './modules/documentoreceber';
import contacorrente from './modules/contacorrente';
import vendas from './modules/vendas';
import filter from './modules/filter';
import scroll from './modules/infinite-scroll';
import inventarioitens from './modules/inventarioitens';
import condicional from './modules/condicional';
import produto from './modules/produto';
import inventario from './modules/inventario';
import pedidovendas from './modules/pedidovendas';
import ordemdeservico from './modules/ordemdeservico';
import ordemservicoitem from './modules/ordemservicoitem';
import estoqueprodutos from './modules/estoqueprodutos';
import turnocaixa from './modules/turnocaixa';
import movimentocaixa from './modules/movimentocaixa';

Vue.use(Vuex);

export default new Vuex.Store({
  actions: {
    async $_setup({ dispatch }) {
      await dispatch('auth/$_setup');
    },
  },

  modules: {
    auth,
    users,
    producao,
    empresa,
    permissao,
    controlesequencia,
    contrato,
    modulos,
    documentopagar,
    documentoreceber,
    contacorrente,
    vendas,
    scroll,
    filter,
    inventarioitens,
    condicional,
    produto,
    inventario,
    pedidovendas,
    ordemdeservico,
    ordemservicoitem,
    estoqueprodutos,
    turnocaixa,
    movimentocaixa,
  },
  plugins: [createPersistedState({
    paths: ['prevenda', 'formapagto'],
    storage: window.sessionStorage,
  })],
});
